import React, { FC, MouseEvent } from "react";
import InlineSvg from "Shared/components/inline-svg";
import Spinner from "Shared/components/spinner";
import { joinClassNames as c } from "Shared/util/styles";
import styles from "./settings-card.css";
import { SettingsCardProp, SettingsCardStatusType } from "./types";
import { getStatusTypeClass, isSvgHeader } from "./utils";

export const SettingsCard: FC<SettingsCardProp> = ({
    action,
    className,
    content,
    header,
    status,
}) => {
    const { disabled, loading, onClick, svg, text } = action || {};

    const isClickable = !!onClick && !loading && !disabled;

    const handleClicked = (event?: MouseEvent<HTMLDivElement>) => {
        if (isClickable) {
            onClick(event);
        }
    };

    const statusType: SettingsCardStatusType | undefined =
        typeof status === "string" ? status : status?.type;

    const statusText: string =
        typeof status === "string" ? "" : status?.text || "";

    return (
        <div
            className={c(
                styles.container,
                isClickable && styles.clickable,
                className,
            )}
            onClick={handleClicked}
        >
            {statusType && (
                <div
                    className={c(
                        styles.statusContainer,
                        getStatusTypeClass(statusType),
                    )}
                >
                    {statusText}
                </div>
            )}
            <div
                className={c(styles.cardContainer, !action && styles.oneColumn)}
            >
                <div>
                    {header && (
                        <div className={styles.headerContainer}>
                            {isSvgHeader(header) ? (
                                <InlineSvg
                                    className={styles.headerSvgContainer}
                                    src={header.svg}
                                />
                            ) : (
                                <div className={styles.headerText}>
                                    {header.text}
                                </div>
                            )}
                        </div>
                    )}
                    <div className={styles.contentContainer}>{content}</div>
                </div>
                {action && (
                    <div className={styles.actionContainer}>
                        {text && (
                            <span className={styles.actionText}>{text}</span>
                        )}
                        {loading ? (
                            <Spinner
                                customClass={styles.actionSpinnerContainer}
                            />
                        ) : disabled ? null : (
                            svg && (
                                <InlineSvg
                                    src={svg}
                                    className={styles.actionSvgContainer}
                                />
                            )
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
